/**
 * Global logout handler to stop all API calls and clear state
 */
class LogoutHandler {
  private static instance: LogoutHandler;
  private isLoggedOut = false;
  private listeners: (() => void)[] = [];

  static getInstance(): LogoutHandler {
    if (!LogoutHandler.instance) {
      LogoutHandler.instance = new LogoutHandler();
    }
    return LogoutHandler.instance;
  }

  setLoggedOut(loggedOut: boolean): void {
    this.isLoggedOut = loggedOut;
    
    if (loggedOut) {
      // Notify all listeners that user has logged out
      this.listeners.forEach(listener => listener());
    }
  }

  isUserLoggedOut(): boolean {
    return this.isLoggedOut;
  }

  addLogoutListener(listener: () => void): void {
    this.listeners.push(listener);
  }

  removeLogoutListener(listener: () => void): void {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  reset(): void {
    this.isLoggedOut = false;
    this.listeners = [];
  }
}

export const logoutHandler = LogoutHandler.getInstance();
export default logoutHandler;